<template>
  <div>
    <!-- <img v-if="stations_or_density[1] == 'density'" class="legend" v-bind:src="legend_img" width="auto" height="auto"> -->
    <div v-if="stations_or_density[1] == 'density'" class="plotly-legend">
      <div id="leyenda" class="colorscale" :style="backgroundLeyend"></div>
      <!-- <div id="leyenda" class="colorscale" ></div> -->

      <div class="legend-numbers">
        <div>{{ legend_max }}</div>
        <div style="flex: 1;"></div>
        <div>{{ legend_min }}</div>
      </div>
    </div>
    <div id="map" class="map-container">
      <!-- <info v-if="transect_status > 0 && transect_status < 4"></info> -->
    </div>
    <MapDash defaultCurrentMapView = 1 ></MapDash>
    <panel></panel>
    <popUpGraph v-show="show_popup" ref='popup' :station="selected_station" :platforms="platforms"></popUpGraph>
    <graph_1 v-if="stations_or_density[2] == 'transect'"></graph_1>
    <graph_2 v-if="stations_or_density[3] == 'serie_temp'"></graph_2>
    
  </div>
</template>

<script>
// Leaflet
import "leaflet/dist/leaflet.css"
import L, { LatLng, layerGroup, polyline } from "leaflet"

// Vuex
import { mapGetters } from 'vuex'

// Components
import panel from '@/components/mapparams/panel'
import MapDash from '@/components/MapDash'
import popUpGraph from '@/components/mapparams/popUpGraph'
import graph_1 from "@/components/mapparams/graph_1.vue"
import graph_2 from "@/components/mapparams/graph_2.vue"
import info from "@/components/mapparams/info.vue"
var convert = require('xml-js')

// Functions
import {getData,getOutsideData, checkWorkspaces, setData} from './../services/api'
import Info from './mapparams/info.vue'

export default {
  name: 'MapParams',
  props: {
    backgroundImage: String
  },
  components: {
    panel,
    MapDash,
    popUpGraph,
    graph_1,
    graph_2,
    info
  },
  data: function () {
    return {
      map: null,
      map_layers: [],
      last_layer: null,
      timeout: undefined,
      colorRoute:'',
      polilyne_group: L.layerGroup(),
      // points: [],
      clicks: 0,

      platforms: [],
      platform_markers: [],

      icon_platforms: {},
      icon_platforms_selected: {},

      show_popup: true,
      selected_station: null,
      compare: "none", // none /stations / params

      legend_min: 0,
      legend_max: 100,
    }
  },
  computed:{
    ...mapGetters(
        "map_params",{
            stations_or_density: 'stations_or_density',
            selected_param: 'selected_param',
            selected_depth: 'selected_depth',
            selected_campaign_data: 'selected_campaign_data',
            campaign_datas_filtered: 'campaign_datas_filtered',
            legend_img: 'get_legend_img',
            transect_points: 'transect_points',
            show_graph_1: 'show_graph_1',
            conox_max_min_values: 'conox_max_min_values',
            porox_max_min_values: 'porox_max_min_values',
            cl_max_min_values: 'cl_max_min_values',
            sal_max_min_values: 'sal_max_min_values'
        }
    ),
    transect_status: {
        set (status) { this.$store.dispatch('map_params/change_transect_status', status); },
        get () { return this.$store.state.map_params.transect_status }
    },
    serie_status: {
        set (status) { this.$store.dispatch('map_params/change_serie_status', status); },
        get () { return this.$store.state.map_params.serie_status }
    },
    bgImage () {
      if (this.colorRoute != '' )
        return require("@/assets/img/params/" + this.colorRoute)
      else 
        return require(`@/assets/img/params/clorofila.jpg`)
    },
    backgroundLeyend () {
      return {
        backgroundImage: `url(${this.bgImage})` 
      }
    }

  },
  watch: {
    'stations_or_density': function () {
      this.changeStationsOrDensity()
    },
    'selected_param': function () {
      this.updateDensityLayer()
    },
    'selected_depth': function () {
      this.updateDensityLayer()
    },
    'selected_campaign_data': function () {
      this.updateDensityLayer()
    },
    'transect_status': function () {
      this.manageTransectStatus()
    },
    'serie_status': function () {
      this.manageSerieTransectStatus()
    },
  },
  beforeMount() {
    //this.$store.dispatch('refresh_token')
  },
  mounted () {
    this.$store.dispatch("ui/change_current_map_view", 1)
    this.setBaseMap()
    this.getPlatformList()
    this.loadIcons()
  },
  methods: {
    setBaseMap: function () {
      this.map = L.map("map", {zoomControl: false}).setView([37.7, -0.8], 12);
      //"https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
      L.tileLayer(
        'https://{s}.tile.jawg.io/jawg-terrain/{z}/{x}/{y}{r}.png?access-token=aVNdgpk2jRMxyTf9hTCiFFCVutZfk96do8eJQFJia2lCMTqILn6xzrbYevBAseQG',
        {
          attribution:
            '&copy; <a href="https://www.ctninnova.com/en/">Centro Tecnológico Naval y del Mar</a>',
            // maxNativeZoom:22,
            // maxZoom:23
        }
      ).addTo(this.map)
      L.control.scale({imperial: false}).addTo(this.map)
      let globalThis = this
      this.map.on('zoomend', function() {
        console.log(globalThis.map.getZoom())
      });
    },
    changeStationsOrDensity: function() {
      this.updateDensityLayer()
      if(this.stations_or_density[0] == 'stations') {
        // this.updateDensityLayer()
        this.setStationsMarkers()
        // this.map.off('click',this.drawTransect)
        // this.polilyne_group.clearLayers();
        // this.$store.commit('map_params/set_show_graph_1', false)
      }
      else {
        this.removeStationsMarkers()
      }
      // if(this.stations_or_density[1] == 'density'){
      //   this.updateDensityLayer()
      //   // this.removeStationsMarkers()
      //   // this.map.off('click',this.drawTransect)
      //   // this.polilyne_group.clearLayers();
      //   // this.$store.commit('map_params/set_show_graph_1', false)
      // }
      if(this.stations_or_density[2] == 'transect'){
        // Show transect
        // this.addPolyline()

        // this.updateDensityLayer()
        // this.removeStationsMarkers()
        // // this.map.on('click',this.drawTransect)
      }
      else {
        // hide transect
        this.removeTransect()
      }

      
    },
    manageTransectStatus: function() {
      if(this.transect_status == 1) {
        this.map.on('click',this.drawTransect)
      }
      else if(this.transect_status == 2) {
      }
      else if(this.transect_status == 3) {
        this.map.off('click',this.drawTransect)
      }
    },
    manageSerieTransectStatus: function() {
      if(this.serie_status == 1) {
        this.map.on('click',this.drawSerieTransect)
      }
      else if(this.serie_status == 2) {
      }
      else if(this.serie_status == 3) {
        this.map.off('click',this.drawSerieTransect)
      }
    },
    drawSerieTransect: function(e){
      this.clicks += 1;

      if (this.clicks > 2){
        this.clicks=1;
        this.polilyne_group.clearLayers();
        // this.transect_points.length = 0
        this.$store.dispatch('map_params/change_serie_transect_points', [])
      } 

      //let temp_points = this.transect_points
      let temp_points = []
      if(this.transect_points.length == 1){
        temp_points.push(this.transect_points[0]);
        this.serie_status = 2
      }

      let image_marker = require('@/assets/icons/marker_transect.svg')
      var Icono = L.icon({
        iconUrl: image_marker,
        iconSize:     [14, 14], // size of the icon
        iconAnchor:   [7, 7], // point of the icon which will correspond to marker's location
        popupAnchor:  [0, -18] // point from which the popup should open relative to the iconAnchor
      })
      L.marker(e.latlng, {
        draggable:false,
        opacity: 1,
        icon: Icono
        }).addTo(this.polilyne_group).addTo(this.map)

      temp_points.push(e.latlng);
      this.$store.dispatch('map_params/change_serie_transect_points', temp_points)

      if(temp_points.length == 2){
        if(temp_points[0].lng > -0.87 && temp_points[0].lng <-0.68 && temp_points[1].lng > -0.87 && temp_points[1].lng < -0.68 && temp_points[0].lat > 37.6 && temp_points[0].lat < 37.83 && temp_points[1].lat > 37.6 && temp_points[1].lat <37.83){
          this.$noty.success("Calculando...")
          this.serie_status = 3
        }
        else{
          this.$noty.error("El transecto seleccionado está fuera del mapa")
          this.serie_status = 1

        }
      }

      if (this.clicks === 2){
        this.addPolyline()
      }  
    },
    drawTransect: function(e){
      this.clicks += 1;

      if (this.clicks > 2){
        this.clicks=1;
        this.polilyne_group.clearLayers();
        // this.transect_points.length = 0
        this.$store.dispatch('map_params/change_transect_points', [])
      } 

      //let temp_points = this.transect_points
      let temp_points = []
      if(this.transect_points.length == 1){
        temp_points.push(this.transect_points[0]);
        this.transect_status = 2
      }

      let image_marker = require('@/assets/icons/marker_transect.svg')
      var Icono = L.icon({
        iconUrl: image_marker,
        iconSize:     [14, 14], // size of the icon
        iconAnchor:   [7, 7], // point of the icon which will correspond to marker's location
        popupAnchor:  [0, -18] // point from which the popup should open relative to the iconAnchor
      })
      L.marker(e.latlng, {
        draggable:false,
        opacity: 1,
        icon: Icono
        }).addTo(this.polilyne_group).addTo(this.map)

      temp_points.push(e.latlng);
      this.$store.dispatch('map_params/change_transect_points', temp_points)

      if(temp_points.length == 2){
        if(temp_points[0].lng > -0.87 && temp_points[0].lng <-0.68 && temp_points[1].lng > -0.87 && temp_points[1].lng < -0.68 && temp_points[0].lat > 37.6 && temp_points[0].lat < 37.83 && temp_points[1].lat > 37.6 && temp_points[1].lat <37.83){
          this.$noty.success("Calculando...")
          this.transect_status = 3
        }
        else{
          this.$noty.error("El transecto seleccionado está fuera de la zona del Mar Menor")
          this.transect_status = 1

        }
      }
      
      if (this.clicks === 2){
        this.addPolyline()
      }  
    },

    removeTransect: function () {
      this.map.removeLayer(this.polilyne_group)
    },

    addPolyline: function () {
        var transect = L.polyline(this.transect_points, {
        color: 'rgb(255,103,0)',
        weight: 5,
        opacity: 1
      })
      transect.addTo(this.polilyne_group)
      this.polilyne_group.addTo(this.map)
    },

    updateDensityLayer: function () {
      if(this.stations_or_density[1] == 'density') {
        let campaignDataId = this.campaign_datas_filtered[this.selected_campaign_data].id
        this.last_layer = L.tileLayer.wms(process.env.VUE_APP_GEOSERVER_HOST + process.env.VUE_APP_WORKSPACE + '/wms', {
              layers: 'water_parameter_' + campaignDataId + '_' + this.layerName(),
              format: 'image/png',
              transparent: true,
              opacity: 1
        }).addTo(this.map);
        this.map_layers.push(this.last_layer)
        this.getLegend();


        // ---------------------------------------------------------------------------------------------------
        //                                 THIS BLOCK TO TEST MOSAICS ON LEAFLET
        // ---------------------------------------------------------------------------------------------------
        // //https://geoserver.ctnmapserver.dev/geoserver/OOMUR_pablo_s/mosaic_campaign_2/wms
        // var url = process.env.VUE_APP_GEOSERVER_HOST + process.env.VUE_APP_WORKSPACE + "/wms"
        // this.last_layer = L.tileLayer.wms(url, {
        //       layers: 'mosaic_campaign_1',
        //       format: 'image/png',
        //       transparent: true,
        //       opacity: 1,
        //       maxZoom: 23
        // }).addTo(this.map);
        // this.map_layers.push(this.last_layer)

        // var url = process.env.VUE_APP_GEOSERVER_HOST + process.env.VUE_APP_WORKSPACE + "/mosaic_campaign_1" + "/wms?request=GetCapabilities"
        // getOutsideData(url).then(res=> {
        //   var result = convert.xml2json(res.data, {compact: true})
        //   var coordinatesMosaicsCampaigns = JSON.parse(result)
        //   console.log(coordinatesMosaicsCampaigns)
        //   var longitude = coordinatesMosaicsCampaigns.WMS_Capabilities.Capability.Layer.EX_GeographicBoundingBox.eastBoundLongitude['_text']
        //   var latitude = coordinatesMosaicsCampaigns.WMS_Capabilities.Capability.Layer.EX_GeographicBoundingBox.northBoundLatitude['_text']
        //   console.log(longitude)
        //   console.log(latitude)
        
        //   let markerOptions = {
        //     title: 'Test',
        //     clickable: true,
        //     draggable: false,
        //     icon: this.icon_platforms
        //   }

        //   var platform_markers = new L.Marker([latitude, longitude], markerOptions)
        //   platform_markers.addTo(this.map).bindPopup(()=>this.$refs.popup.$el, {maxWidth: 700})
        // })
      }
      // else if(this.stations_or_density[2] == 'transect'){
      //   this.$store.dispatch('map_params/change_transect_points', this.transect_points)
      // }
      else {
        this.last_layer = null
      }

      // After 1 second, map layers are cleared (except for the last one). They are not cleared immediatly so
      // layers can fade in, transitioning from the former to the new one.
      // Timeout is in a var, so it can be cleared and re-set if user changes layers too fast. Preventing multiple
      // calls to the clearLayers() function.
      clearTimeout(this.timeout);
      if(this.stations_or_density[1] == 'density') {
        this.timeout = setTimeout(() => {
          this.clearLayers()
        }, 1000);
      }
      else {
        this.clearLayers()
      }
    },

    layerName: function () {
      let layerName = ''
      switch (this.selected_param) {
        case 1:
          layerName = 'ConOxigenoDisuelto_'
          break
        case 2:
          layerName = 'PorOxigenoDisuelto_'
          break
        case 3:
          layerName = 'Clorofila_'
          break
        case 4:
          layerName = 'Salinidad_'
          break
      }
      switch (this.selected_depth) {
        case 0:
          layerName += 'bottom'
          break
        case 1:
          layerName += 'surface'
          break
      }
      return layerName
    },

    clearLayers: function () {
      this.map_layers.forEach(layer => {
        if(layer != this.last_layer) {
          this.map.removeLayer(layer)
        }
      })

      this.map_layers = []

      if(this.last_layer != null) {
        this.map_layers.push(this.last_layer)
      }
    },

    // **************** STATIONS **********************
    getPlatformList: function () {
      var url = 'campaign/platforms/'
      getData(url).then(res=> {
        res.data.platforms.forEach(platform => {
          if(platform.geometry) {
            this.platforms.push(platform)
          }
        })
        if(this.stations_or_density[0] == 'stations') {
          this.setStationsMarkers()
        }
      })
    },
    loadIcons: function () {
      let image_marker = require('@/assets/icons/station_marker.svg')
      this.icon_platforms = L.icon({
        iconUrl: image_marker,
        iconSize:     [20, 20], // size of the icon
        iconAnchor:   [10, 10], // point of the icon which will correspond to marker's location
        popupAnchor:  [0, -18] // point from which the popup should open relative to the iconAnchor
      })

      let image_marker_selected = require('@/assets/icons/station_marker_selected.svg')
      this.icon_platforms_selected = L.icon({
        iconUrl: image_marker_selected,
        iconSize:     [20, 20], // size of the icon
        iconAnchor:   [10, 10], // point of the icon which will correspond to marker's location
        popupAnchor:  [0, -18] // point from which the popup should open relative to the iconAnchor
      })
    },
    setStationsMarkers: function () {
      this.platform_markers.forEach(platform => {
        this.map.removeLayer(platform)
      })
      this.platform_markers = []
      for(let i = 0; i < this.platforms.length; i++) {
          let markerOptions = {
            title: this.platforms[i].properties.name,
            clickable: true,
            draggable: false,
            icon: this.icon_platforms
          }
  
          this.platform_markers[i] = new L.Marker([this.platforms[i].geometry.coordinates[1], this.platforms[i].geometry.coordinates[0]], markerOptions)
          this.platform_markers[i].addTo(this.map).bindPopup(()=>this.$refs.popup.$el, {maxWidth: 700})

          let globalThis = this
          this.platform_markers[i].on('click', function(e) {
            for(let j = 0; j < globalThis.platforms.length; j++) {
              if (i == j) {
                globalThis.platform_markers[j].setIcon(globalThis.icon_platforms_selected)

                //console.log(globalThis.platforms[j].properties)
                globalThis.$store.dispatch('map_params/change_selected_param_compare', 0)
                document.getElementsByClassName("leaflet-popup-content")[0].style.width = "500px";
                document.getElementsByClassName("ploty-container")[0].style.width = "500px";
                globalThis.selected_station = globalThis.platforms[j].properties
              }
              else {
                globalThis.platform_markers[j].setIcon(globalThis.icon_platforms)
              }
            }
          })
      }
    },
    removeStationsMarkers: function () {
      this.platform_markers.forEach(platform => {
        this.map.removeLayer(platform)
      })
      this.platform_markers = []
    },
    getLegend: function() {
      // let campaignDataId = this.campaign_datas_filtered[this.selected_campaign_data].id
      // let url = process.env.VUE_APP_GEOSERVER_HOST + process.env.VUE_APP_WORKSPACE + "/water_parameter_" + campaignDataId + "_" + this.layerName() + "/wms?request=GetCapabilities"
      // getOutsideData(url).then(res=> {
      //       let result = JSON.parse(convert.xml2json(res.data, {compact: true}))
      //       let legendUrl = result.WMS_Capabilities.Capability.Layer.Layer.Style.LegendURL.OnlineResource._attributes["xlink:href"]
      //       this.$store.dispatch('map_params/change_legend_img', legendUrl) // crear este estado y mostrarlo en el mapa (arriba en el HTML v-if heatmap && legend != null)
      //     })
      if(this.selected_param == 1) {
        this.legend_min = '' + this.conox_max_min_values[0] + ' mg/L'
        this.legend_max = '' + this.conox_max_min_values[1] + ' mg/L'
        this.colorRoute = 'conOxigeno.jpg'
      }
      else if (this.selected_param == 2) {
        this.legend_min = '' + this.porox_max_min_values[0] + ' %'
        this.legend_max = '' + this.porox_max_min_values[1] + ' %'
        this.colorRoute = 'porOxigeno.jpg'
      }
      else if (this.selected_param == 3) {
        this.legend_min = '' + this.cl_max_min_values[0] + ' µg/L'
        this.legend_max = '' + this.cl_max_min_values[1] + ' µg/L'
        this.colorRoute = 'clorofila.jpg'
      }
      else if (this.selected_param == 4) {
        this.legend_min = '' + this.sal_max_min_values[0] + ' PSU'
        this.legend_max = '' + this.sal_max_min_values[1] + ' PSU'
        this.colorRoute = 'salinidad.jpg'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  .legend{
    position: absolute;
    z-index: 10000;
    float: left;
    margin: 1rem;
    mix-blend-mode: multiply;
  }

  .plotly-legend {
    position: absolute;
    z-index: 10000;
    float: left;
    margin: 1rem;
    height: 100px;
    width: 100px;
    display: flex;
    flex-direction: row;
  }
  .colorscale {
    width: 35px;
    height: 100%;
    border-radius: 5px;
    border: 0px solid white;
    /* background: linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,212,255,1) 100%); */
    /* background-image: url('~@/assets/img/params/colorscale_conOxigeno.png'); */
    background-size: contain;
  }
  .legend-numbers {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding-left: 6px;
    font-size: 0.9rem;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/MapParams.vue